export default __webpack_public_path__ + "static/media/home_ico.c1fb8cd8.svg";